import { Flex } from "antd";
import { FC } from "react";

import { StyledExclamationCircleOutlined } from "@/app/ProgressLoader/Styled";
import BaseButton from "@/components/BaseButton";
import { BaseModal } from "@/components/BaseModal";
import { SecondaryText } from "@/components/Typography/Styled";

interface DeleteShelfModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteShelfModal: FC<DeleteShelfModalProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <BaseModal
            title="Ви впевнені?"
            open={open}
            onClose={onClose}
            actions={null}
            icon={<StyledExclamationCircleOutlined />}
            maskClosable
        >
            <SecondaryText textAlign="center">
                Стелаж буде видалений разом з усіма полицями. Ви впевнені, що
                хочете продовжити?
            </SecondaryText>

            <Flex vertical gap={8}>
                <BaseButton type="primary" onClick={onConfirm}>
                    Видалити стелаж
                </BaseButton>

                <BaseButton type="default" onClick={onClose}>
                    Повернутися назад
                </BaseButton>
            </Flex>
        </BaseModal>
    );
};
